import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import convertToEnglishNumbers from "../../function/convertToEnglishNumbers";

const customInput = forwardRef(({ onChange, ...props }, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      onChange={e => {
        const value = convertToEnglishNumbers(e.target.value);
        e.target.value = value;
        onChange(e);
      }}
    />
  );
});

/**
 * @param {import('react-number-format').NumericFormatProps} props
 */

export default function NumericInput(props) {
  return (
    <NumericFormat customInput={customInput} thousandSeparator="," {...props} />
  );
}
